document.addEventListener('DOMContentLoaded', () => {
  const planBreakdowns = document.querySelectorAll('.plan-breakdown');

  // Use event delegation for better performance
  planBreakdowns.forEach(planBreakdown => {
    const section = planBreakdown.closest('.shopify-section');
    if (!section) return;

    // Cache DOM elements
    const trigger = section.querySelectorAll('[data-plan-trigger]');
    const elements = section.querySelectorAll('[data-plan]');

    // Use event delegation on the section
    section.addEventListener('click', event => {
      const trigger = event.target.closest('[data-plan-trigger]');
      if (!trigger || trigger.classList.contains('plan-breakdown__plan-btn--active')) {
        return;
      }

      const plan = trigger.dataset.plan;
      const targets = Array.from(elements).filter(el => el.dataset.plan === plan);

      if (!targets.length) return;

      elements.forEach(element => {
        const firstClass = element.classList[0];
        const activeClass = `${firstClass}--active`;

        element.classList.contains(activeClass) ? element.classList.remove(activeClass) : null;
      });

      targets.forEach(target => {
        const firstClass = target.classList[0];
        const activeClass = `${firstClass}--active`;

        target.classList.add(activeClass);
      });
    });
  });
});
